module.exports = __webpack_public_path__ + "img/nimblr.1687d18e.svg";